<template>
  <v-hover v-slot="{ hover }">
    <v-card :disabled="imovel.attributes[7].value === `true`" style="margin: 0 10px; background-color: #0b202e;" v-if="imovel"
      :elevation="hover ? 12 : 2" :class="categoria === 'aluguel' || imovel.vendido ? 'opaco' : ''"
      class="mx-auto my-12 " max-width="300" max-height="560" min-height="560">
      <template slot="progress">
        <v-progress-linear color="" height="10" indeterminate></v-progress-linear>
      </template>
      <v-carousel hide-delimiter-background dark delimiter-icon="mdi-minus" style="height: 221px" light id="cases"
        class="d-flex justify-center flex-column pt5" v-if="imovel.files.length > 0">
        <template v-slot:prev="{ on, attrs }">
          <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-left</v-icon>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-right</v-icon>
        </template>

        <v-carousel-item v-for="(img, i) in imovel.files.slice(0, 6)" :key="i">
          <v-sheet tile style="background-color: transparent">
            <v-row align="center">
              <v-col cols="12" md="12">
                <!-- <v-img width="100%" height="221px" max-height="221px" v-if="img.file_storage != undefined" :src="`${$root.$publicUrl}/files/load-full-image/${img.file_storage.id}/${$root.$options.filters.sanitizeTitle(img.file_storage.name)}
                .${img.file_storage.extension}`">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#ff770f70"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img> -->
                <v-img width="100%" height="221px" max-height="221px" v-if="img.url != undefined" :src="img.url">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#ff770f70"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
      <v-img height="221px" style="opacity:0.4" src="../assets/no-image.png" v-if="imovel.files.length === 0"></v-img>
      <v-card-title class="d-flex flex-column align-start" style="padding: 5px 16px !important">
        <p style="margin-bottom: 5px; max-height: 25px; overflow: hidden; color: #fff">
          {{ imovel.title }}
        </p>
        <small style="color: #b3b3b3">
          {{ imovel.attributes[6].value.city }} - {{ imovel.attributes[6].value.state }}
        </small>
      </v-card-title>
      <v-card-text style="min-height: 130px; color: #fff">
        <v-row align="center" class="mx-0" v-show="imovel.attributes[7].value === `false`">
          <div class="my-4 text-subtitle-1">
            <p class="mb-0" style="min-height:20px">
              <span v-show="imovel.price != null && imovel.price !== `0.00`">De </span>
              <span v-show="imovel.price != null && imovel.price !== `0.00`"
                style="text-decoration: line-through; font-family: sofia pro">{{ imovel.price | cash }}</span><br />
            </p>
            <p class="mb-0">
              <span style="font-family: sofia pro; color: #fff">Por <span style="color: #FF770F">{{ valorRibus() | cashRibs }}</span>
                + {{ valorReais() | cash }}</span>
            </p>
         
          </div>
        </v-row>
        <h1 style="text-align: center;" v-if="imovel.attributes[7].value === `true`">VENDIDO</h1>

        <div style="min-height: 50px; max-height: 50px" v-html="imovel.short_description.substring(0, 95)"></div>
      </v-card-text>
      <v-card-actions class="py-1 d-flex">
        <v-btn  block :to="{
          path: imovel.attributes[7].value === `true`
            ? '/busca/imoveis/'
            : categoria === 'aluguel'
              ? '/busca/aluguel'
              : categoria === 'imoveis'
                ? '/ver/imovel/' + imovel.id
                : '/ver/imovel/' + imovel.id,
        }" :class="imovel.vendido ? `btnVendido` : `btnLimpar`" style="color: #fff !important; border-radius: 20px; border: 1px solid #FF770F; margin: 7px 0px;" text
          :disabled="categoria === 'aluguel' ? true : false">
          {{
              categoria === "aluguel"
                ? "Em Breve"
                : imovel.attributes[7].value === `true`
                  ? "Vendido"
                  : "Saiba Mais"
          }}
        </v-btn>
      </v-card-actions>
      <div style="padding: 10px; background-color: #ed7d2eb5; text-align: center"
        class="d-flex justify-center align-center">
        <p style="margin-bottom: 0px !important; color: #fff">Parceiro {{ imovel.user.firstname }} aceita <br> <span
            style="color: #fff; font-weight: bold; font-size: 20px">
            {{ Math.trunc(imovel.accepted_tokens_percentual) }}%</span> em Ribus.</p>
      </div>
    </v-card>
  </v-hover>
</template>
<style scoped>
.vendidoef {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-weight: 800;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  height: 100%;
  width: 100%;
  background-color: #00294b;
  padding-top: 80%;
  text-align: center;
}

.btnPercent {
  color: #FF770F;
  font-family: "sofia pro";
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1px;
  /* position: absolute; */
  /* top: 56px; */
  /* left: 22px; */
}
</style>
<script>
export default {
  name: "CardImovel",
  props: { imovel: Object, categoria: String },
  data: () => ({}),
  mounted() {
    if (typeof this.imovel.attributes[6].value == "string") {
      this.imovel.attributes[6].value = JSON.parse(this.imovel.attributes[6].value);
    }
    //if (typeof this.imovel.attributes[7].value === "string") {
      //this.imovel.attributes[7].value = this.imovel.attributes[7].value === `true`;
      //this.$forceUpdate()
    //}
  },
  computed: { 
    cotacao() {
      return this.$store.state.ribus;
    },
  },
  methods: { 
    valorRibus() { 
      let cotacao = this.cotacao.venda
      let qtdeRibus = (((Math.trunc(this.imovel.accepted_tokens_percentual)/100) * this.imovel.sale_price) / cotacao )
      return qtdeRibus
    },
    valorReais() { 
      let qtdeReais = (this.imovel.sale_price - ((Math.trunc(this.imovel.accepted_tokens_percentual)/100) * this.imovel.sale_price))
      return qtdeReais
    }
  }
};
</script>
